module.exports = __webpack_public_path__ + "img/em_manutencao.cc27aca8.png";